import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import ImageUploadStepFive from '@brands/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadStepFive';
import { selectAuth } from '@brands/store/selectors/auth';
import { AuthState } from '@brands/store/slices/authSlice';
import React from 'react';

import ImageUploadStepFiveAdminView from '../../../../../default/Dashboard/PatientForms/PatientForm/ImageUpload/ImageUploadStepFive';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import { UserRoleName } from '../../../../services/identity/types/UserProfile';

const ImageUploadStepFiveValidation: React.FC = () => {
  let component: JSX.Element;
  const user: AuthState = useAppSelector(selectAuth);

  switch (user.userInfo?.role.name) {
    case UserRoleName.Patient:
    case UserRoleName.Collector:
    case UserRoleName.CareAdvisor:
      component = <ImageUploadStepFive />;
      break;
    case UserRoleName.OrganizationAdmin:
    case UserRoleName.SuperAdmin:
    case UserRoleName.Admin:
      component = <ImageUploadStepFive />;
      break;
    default:
      component = <NotFoundPage />;
      break;
  }

  return <div>{component}</div>;
};

export default ImageUploadStepFiveValidation;
